import { createApp } from 'vue';
import { createPinia } from 'pinia'
import  { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

library.add(fas, far, fab);

// import { ZiggyVue } from 'ziggy';
// import { Ziggy } from './ziggy';


// Pinia (New VueX store)
const pinia = createPinia()

// Components
import Home from './components/Home.vue';
import Categories from './components/Categories.vue';
import Notifications from './components/Notifications.vue';
import Dashboard from './components/Dashboard.vue';
import Deals from './components/Deals.vue';
import Deal from './components/Deal.vue';
import VueFooter from './components/VueFooter.vue';
import ChannelSetup from './components/ChannelSetup.vue';
import NotifyMe from "./components/NotifyMe";

import Image from "./components/deal/Image.vue";
import Bids from "./components/deal/auction/Bids.vue";
import Auction from "./components/deal/auction/Auction.vue";
import Auctions from "./components/deal/auction/Auctions.vue";
import AuctionsEndDate from "./components/deal/auction/AuctionsEndDate.vue";
import BidRow from "./components/deal/auction/BidRow.vue";
import HighestBidder from "./components/deal/auction/HighestBidder.vue";

import Timer from "./components/elements/Timer.vue"
import TimerEndDate from "./components/elements/TimerEndDate.vue"
import Panel from "./components/elements/Panel.vue"


require('./bootstrap');




const app = createApp({}).mixin({methods: { route: window.route }});

app.use(pinia)

app.config.globalProperties.$filters = {
    formatNumber(number) {
        if (!number) {
            return '-';
        }
        return Intl.NumberFormat().format(number);
    }
}

app.component('home', Home)
app.component('categories', Categories)
app.component('notifications', Notifications)
app.component('vuefooter', VueFooter)
app.component('dashboard', Dashboard)
app.component('channelsetup', ChannelSetup)
app.component('deals', Deals)
app.component('deal', Deal)
app.component('notifyme', NotifyMe)

app.component('deal-image', Image)
app.component('bids', Bids)
app.component('bid-row', BidRow)
app.component('auction', Auction)
app.component('auctions', Auctions)
app.component('auctions-ending', AuctionsEndDate)
app.component('auction-highest-bidder', HighestBidder)
app.component('panel', Panel)

// Elements

app.component('timer', Timer)
app.component('timer-end', TimerEndDate)

.component('fa' ,  FontAwesomeIcon)
    .mount('#app');

